// How long to wait, said the locale's own way (D-494's sign-in throttle).
// The server's Retry-After is whole seconds; under a minute it reads in
// seconds, from a minute up in whole minutes rounded up, so the wait shown
// is never shorter than the one the server will hold to. Intl carries each
// language's plural rules, which a catalogue string with a bare number
// cannot (Russian alone has three forms).

export function formatWait(seconds: number, locale: string): string {
  const whole = Math.max(1, Math.ceil(seconds));
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "always" });
  return whole < 60 ? rtf.format(whole, "second") : rtf.format(Math.ceil(whole / 60), "minute");
}
